module.exports = __webpack_public_path__ + "static/p4-0d214a16bad5dfc20510a80b92073535.jpg";